module.exports = __webpack_public_path__ + "img/8pwd.04a6865c.png";